import { Component, OnInit } from '@angular/core';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-internet-check',
  templateUrl: './internet-check.component.html',
  styleUrls: ['./internet-check.component.scss']
})
export class InternetCheckComponent implements OnInit {
  interval;
  constructor(public localService: LocalService) { }

  ngOnInit(): void {

    this.startTimerToCheckOnline();
  }

  onCheckOnline() {
    this.localService.isInternetAvailable = navigator.onLine;
  }

  startTimerToCheckOnline() {
    this.interval = setInterval(() => {
      this.onCheckOnline();
    }, 1000); //1 secs
  }
}
